export const buffer = flush => {
  return function() {
    flush.buffer = flush.buffer || [];
    flush.buffer.push(Array.from(arguments));

    return (dispatch, getState) => {
      clearTimeout(flush.timer);
      flush.timer = setTimeout(() => {
        flush(flush.buffer, dispatch, getState);
        flush.buffer = [];
      });
    };
  };
};
